<template>
 <div v-if="show" class="flex flex-col fixed bottom-0 h-full w-full rounded-lg md:rounded-none items-center  justify-end md:justify-center z-[210] modal-overlay">
   <div class="modal-content flex flex-col gap-3 w-full max-w-[720px] h-auto pt-4 pb-6 px-3 md:px-6 bg-white rounded-lg max-h-90">

      <div class="flex flex-row w-full text-center justify-between font-bold">

        <div class="flex items-center flex-row justify-center h-auto w-auto gap-2">
          <img class="w-6 aspect-auto" src="/img/home/battery/emergencyv2.svg" alt="emergencia" />
          <p class="uppercase font-nunito font-bold text-lg md:text-2xl">
            SERVICIO DE RESCATE
          </p>
        </div>

        <button @click="closeModal" class="flex flex-col justify-center items-center h-6 w-6">
          <img src="/img/chat/cerrar.png" alt="Cerrar" class="h-full w-full object-fill" loading="lazy" />
        </button>

      </div>

      <div class="contenedor_texto rounded-md flex flex-col gap-2 px-3 md:px-6 py-6 text-base md:text-lg">
        <p class="text-left text-black text-base">
          Nuestro Servicio de Rescate está diseñado para atender a clientes que
          se encuentran en una situación de urgencia, brindando la máxima
          prioridad en la instalación de baterías.
        </p>

        <p class="text-left text-black text-base">
          Este servicio implica un recargo adicional debido a la atención
          prioritaria que recibirás. Si tu situación no es de urgencia, puedes
          agendar a través de nuestra instalación a domicilio.
        </p>

        <div class="flex justify-center pt-2">
          <a href="tel:225805000" class="cursor-pointer bg-VERDE_TOP_CALIDAD flex h-auto w-auto gap-2 py-2 px-4 items-center justify-center text-lg md:text-2xl font-bold border rounded-md text-VERDE_TOP_CALIDAD border-VERDE_TOP_CALIDAD">
            <img class="w-5 md:w-6 aspect-auto cursor-pointer" :src="'/img/home/battery/call_v2.svg'" alt="phone"/>
            <p class="text-white text-base md:text-base cursor-pointer">Llamar 22 580 5000 </p> 
          </a>
        </div>
      </div>

   </div>
 </div>
</template>

<script>
import { computed } from "vue";
export default {
 props: {
   show: {
     type: Boolean,
     required: true,
   },
 },

 setup(props, { emit }) {
   const show = computed(() => props.show);
   
   function closeModal() {
     emit("closeModal");
   }

   return { closeModal, show};
 },
};
</script>

<style scoped>
.modal-overlay{
  background-color: rgba(0, 0, 0, 0.345);  
  animation: fadeIn 0.3s ease-out;
}
.contenedor_texto {
  background-color: #f6f6f6;
}
/* Animación solo para mobile */
@media (max-width: 768px) {
  .modal-overlay{
    background-color: rgba(0, 0, 0, 0.345);  
    animation: fadeIn 0.3s ease-out;
  }

 .modal-content {
   animation: slideUp 0.3s ease-out;
   transform-origin: bottom;
 }

  @keyframes fadeIn {
   from {
     opacity: 0;
   }
   to {
     opacity: 1;
   }
 }

 @keyframes slideUp {
   from {
     transform: translateY(100%);
   }
   to {
     transform: translateY(0);
   }
 }
}
</style>